export default {"src":"/_next/static/media/AffordableandAccessible.4911644c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};